import { render } from "./PieChartDashboard.vue?vue&type=template&id=c73cea34&scoped=true"
import script from "./PieChartDashboard.vue?vue&type=script&lang=js"
export * from "./PieChartDashboard.vue?vue&type=script&lang=js"

import "./PieChartDashboard.vue?vue&type=style&index=0&id=c73cea34&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73cea34"]])

export default __exports__